import { CountryData, WIRPhaseTypes } from 'types/wellGuardian';

export const getPhaseBackgroundColor = (phaseName: string | undefined, countryState: string) => {
  if (countryState === CountryData.denmark) {
    switch (phaseName) {
      case WIRPhaseTypes.STAGE_GATE_1:
        return 'rgba(255,225,0,215)';
      case WIRPhaseTypes.STAGE_GATE_2:
        return '#CFD3D9';
      case WIRPhaseTypes.STAGE_GATE_3:
        return 'rgb(144,203,86)';
      case WIRPhaseTypes.STAGE_GATE_4:
        return 'rgba(0, 235, 191, 0.1)';
      case WIRPhaseTypes.STAGE_GATE_5:
        return 'rgba(235, 227, 118, 0.2)';
      case WIRPhaseTypes.REACTIVE_SCOPE:
        return '#CFD3D9';
      case WIRPhaseTypes.PAUSED_STATE:
        return '#bfbfbf';
    }
  } else {
    switch (phaseName) {
      case WIRPhaseTypes.WIR_CREATED:
      case WIRPhaseTypes.CG_WIR_CREATED:
        return '#CFD3D9';
      case WIRPhaseTypes.KICK_OFF_TECHNICAL_WIR:
      case WIRPhaseTypes.CG_KICK_OFF_TECHNICAL_WIR:
        return 'rgba(255, 91, 100, 0.2)';
      case WIRPhaseTypes.ENGINEERING_WORK:
      case WIRPhaseTypes.CG_ENGINEERING_WORK:
      case WIRPhaseTypes.AG_ENGINEERING_WORK:
      case WIRPhaseTypes.IRAQ_ENGINEERING_WORK:
      case WIRPhaseTypes.ARGENTINA_ENGINEERING_WORK:
        return 'rgba(0, 120, 234, 0.2)';
      case WIRPhaseTypes.FINAL_WIR:
      case WIRPhaseTypes.CG_FINAL_WIR:
      case WIRPhaseTypes.AG_FINAL_WIR:
      case WIRPhaseTypes.IRAQ_FINAL_WIR:
      case WIRPhaseTypes.ARGENTINA_FINAL_WIR:
        return 'rgba(0, 200, 92, 0.2)';
      case WIRPhaseTypes.FINAL_PREPARATION:
      case WIRPhaseTypes.NG_FINAL_PREPARATION:
      case WIRPhaseTypes.CG_FINAL_PREPARATION:
      case WIRPhaseTypes.AG_FINAL_PREPARATION:
      case WIRPhaseTypes.IRAQ_FINAL_PREPARATION:
      case WIRPhaseTypes.ARGENTINA_FINAL_PREPARATION:
        return 'rgba(221, 139, 47, 0.2)';
      case WIRPhaseTypes.INTERVENTION_OPERATION:
      case WIRPhaseTypes.NG_INTERVENTION_OPERATION:
      case WIRPhaseTypes.CG_INTERVENTION_OPERATION:
      case WIRPhaseTypes.AG_INTERVENTION_CLOSE_OUT:
      case WIRPhaseTypes.IRAQ_INTERVENTION_OPERATION:
      case WIRPhaseTypes.ARGENTINA_INTERVENTION_OPERATION:
        return 'rgba(0, 235, 191, 0.1)';
      case WIRPhaseTypes.INTERVENTION_CLOSE_OUT:
      case WIRPhaseTypes.NG_INTERVENTION_CLOSE_OUT:
      case WIRPhaseTypes.CG_INTERVENTION_CLOSE_OUT:
      case WIRPhaseTypes.AG_INTERVENTION_OPERATION:
      case WIRPhaseTypes.IRAQ_INTERVENTION_CLOSE_OUT:
      case WIRPhaseTypes.ARGENTINA_INTERVENTION_CLOSE_OUT:
        return 'rgba(235, 227, 118, 0.2)';
      case WIRPhaseTypes.REACTIVE_SCOPE:
        return '#CFD3D9';
      case WIRPhaseTypes.PAUSED_STATE:
        return '#bfbfbf';
    }
  }
};
